import { STRINGS } from "@/constants";

export function getErrorMessage(errorCode: string) {
  switch (errorCode) {
    case "404":
      return STRINGS.errors.codes["404"];
    case "500":
      return STRINGS.errors.codes["500"];
    default:
      return STRINGS.errors.codes.default;
  }
}
